import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { push } from "connected-react-router";
import { RankingListAvatar } from "~atoms/RankingListItem/components";
import { CSIcon } from "~icons/rankingList/CSIcon";
import { useAppDispatch } from "~store";
import { formatLargeNumber } from "~utils/formatLargeNumber";
import { getPathWithLanguageCode } from "~utils/languageInURL";
import { numberWithDots } from "~utils/numberWithDots";
import { useStyles } from './UserCard.styles';
export var UserCard = function (_a) {
    var level = _a.level, rank = _a.rank, userName = _a.userName, avatar = _a.avatar, avatarUrl = _a.avatarUrl, stars = _a.stars, balance = _a.balance, currentUserRank = _a.currentUserRank, currentUserLevel = _a.currentUserLevel, ranks = _a.ranks, gameInfo = _a.gameInfo, isGroupRanking = _a.isGroupRanking, isGlobalRanking = _a.isGlobalRanking, isRankingListEmpty = _a.isRankingListEmpty, showJoinGameModal = _a.showJoinGameModal;
    var classes = useStyles();
    var dispatch = useAppDispatch();
    var t = useTranslation('tip-game').t;
    var isCurrentUser = (currentUserLevel && currentUserLevel === level)
        || (currentUserRank && currentUserRank === rank);
    var balanceValue = isGlobalRanking ? formatLargeNumber(balance || 0) : numberWithDots(balance || 0);
    var hasNotPlayed = !balance && !level && !rank;
    var isBalance = balance || balance === 0;
    var renderText = function () {
        if (isRankingListEmpty) {
            return React.createElement("span", { className: classes.description }, t('coming_soon'));
        }
        if (hasNotPlayed) {
            return React.createElement("span", { className: classes.description }, t('ranking-list.not_played'));
        }
    };
    var renderLevel = function () {
        var levelText = !level && !rank ? null : isGlobalRanking || isGroupRanking ? t('rank') : t('level');
        var levelNumber = !level && !rank ? null : isGlobalRanking || isGroupRanking ? rank : level;
        return levelText ? React.createElement("div", { className: classes.level }, "".concat(levelText, " ").concat(levelNumber)) : React.createElement("div", { className: classes.gameName, style: { background: gameInfo.color } }, gameInfo.name);
    };
    var isJoinGameButton = !hasNotPlayed && !isGlobalRanking && !isRankingListEmpty && !level && showJoinGameModal;
    var isShowTicketButton = !isJoinGameButton && !renderText();
    var onShowTipsClick = function (e) {
        e.stopPropagation();
        dispatch(push(getPathWithLanguageCode('/my-tips')));
    };
    return (React.createElement("div", { className: classNames(classes.container, isCurrentUser && classes.greenBorder, (ranks === null || ranks === void 0 ? void 0 : ranks.length) && classes.pointer) },
        renderLevel(),
        React.createElement("div", { className: classes.wrapper },
            React.createElement(RankingListAvatar, { stars: stars, avatar: avatar, avatarUrl: avatarUrl }),
            React.createElement("div", { className: classes.fullWidth },
                React.createElement("div", { className: classes.userName }, userName),
                React.createElement(React.Fragment, null, renderText()),
                React.createElement("div", { className: classes.creditsContainer },
                    isBalance && (React.createElement("div", null,
                        React.createElement("div", { className: classes.creditsText }, isGlobalRanking ? t('ranking-list.status_credits') : !level ? t('bonus_amount') : t('ranking-list.my_credits')),
                        React.createElement("span", { className: classes.credits },
                            React.createElement("span", { className: classes.jackpotCount }, balanceValue),
                            React.createElement(CSIcon, { size: 'sm' })))),
                    isShowTicketButton && (React.createElement("div", { role: "button", tabIndex: 0, className: classes.tipsButton, onClick: function (e) { return onShowTipsClick(e); } }, t('show_ticket'))))),
            isJoinGameButton && (React.createElement("div", { tabIndex: 0, role: "button", className: classes.joinGameButton, onClick: showJoinGameModal }, t('join_the_game'))))));
};
